import { render, staticRenderFns } from "./smartHelmetAddRole.vue?vue&type=template&id=3064b220&scoped=true&"
import script from "./smartHelmetAddRole.vue?vue&type=script&lang=js&"
export * from "./smartHelmetAddRole.vue?vue&type=script&lang=js&"
import style0 from "./smartHelmetAddRole.vue?vue&type=style&index=0&id=3064b220&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3064b220",
  null
  
)

export default component.exports